import { useEffect, useState } from "react";
import { Mail, MessageCircle, Instagram, Music2, Facebook, MapPin } from "lucide-react";
import LegalShell from "../components/LegalShell";
import api from "../lib/api";

export default function Contact() {
  const [c, setC] = useState(null);

  useEffect(() => {
    api.get("/site-settings").then(({ data }) => setC(data)).catch(() => setC({}));
  }, []);

  const wa = (c?.whatsapp || "").replace(/[^0-9]/g, "");
  const cards = c ? [
    c.email && { icon: Mail, label: "Email", value: c.email, href: `mailto:${c.email}`, tid: "contact-email" },
    c.whatsapp && c.whatsapp_enabled !== false && { icon: MessageCircle, label: "WhatsApp", value: c.whatsapp, href: `https://wa.me/${wa}`, tid: "contact-whatsapp" },
    c.instagram && { icon: Instagram, label: "Instagram", value: c.instagram, href: `https://instagram.com/${c.instagram.replace(/^@/, "")}`, tid: "contact-instagram" },
    c.tiktok && { icon: Music2, label: "TikTok", value: c.tiktok, href: `https://www.tiktok.com/@${c.tiktok.replace(/^@/, "")}`, tid: "contact-tiktok" },
    c.facebook && { icon: Facebook, label: "Facebook", value: c.facebook, href: `https://facebook.com/${c.facebook}`, tid: "contact-facebook" },
    c.address && { icon: MapPin, label: "Alamat", value: c.address, href: null, tid: "contact-address" },
  ].filter(Boolean) : [];

  return (
    <LegalShell title="Kontak Kami" icon={Mail} active="contact">
      <div data-testid="contact-page">
        <p className="text-su-muted font-medium mb-6">Ada pertanyaan, kendala pembayaran, atau ingin mengajukan refund? Hubungi kami lewat kanal resmi di bawah ini. Kami usahakan membalas dalam 1x24 jam pada hari kerja.</p>
        <div className="grid sm:grid-cols-2 gap-3">
          {cards.map((x) => {
            const inner = (
              <>
                <div className="w-11 h-11 rounded-2xl bg-su-primary/10 grid place-items-center shrink-0"><x.icon className="w-5 h-5 text-su-primary" /></div>
                <div className="min-w-0">
                  <div className="text-xs font-heading font-black uppercase tracking-wide text-su-muted">{x.label}</div>
                  <div className="font-heading font-extrabold truncate">{x.value}</div>
                </div>
              </>
            );
            return x.href ? (
              <a key={x.tid} data-testid={x.tid} href={x.href} target="_blank" rel="noreferrer"
                className="card-chunky p-4 flex items-center gap-3 hover:-translate-y-0.5 transition-transform">{inner}</a>
            ) : (
              <div key={x.tid} data-testid={x.tid} className="card-chunky p-4 flex items-center gap-3">{inner}</div>
            );
          })}
        </div>
        {c && cards.length === 0 && <p className="text-su-muted text-sm text-center py-8">Informasi kontak belum tersedia.</p>}
      </div>
    </LegalShell>
  );
}
